
import { Component, OnInit } from '@angular/core';
import { ResultData } from 'src/app/_models/ResultData';
import { AdminService } from './../../_services/admin.service';

@Component({
  selector: 'app-admin-enrolments',
  templateUrl: './admin-enrolments.component.html',
  styleUrls: ['./admin-enrolments.component.css']
})
export class AdminEnrollmentsComponent implements OnInit {
  enrolments =[]
  dtOptions: DataTables.Settings = {};
  loading = false
  isEmpty = false
  constructor(
    private adminService:AdminService
  ) { }

  ngOnInit(): void {
    this.loading=true
    this.dtOptions = {
      pagingType: 'full_numbers'
     };
    this.adminService.getEnrollments().subscribe({
      next: (data:ResultData) => {
        this.enrolments=data.rs.data
        this.loading= false
        if(this.enrolments.length==0) this.isEmpty=true
      },
      error: (error) => {
        console.error('Error fetching enrolments', error);
        this.loading=false
      }
    }

    )

  }

}
